import React from "react";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";

import CustomMenu from "../../components/Menu";
import { dataGridColumn } from "./DataGridColumn";

export const ToggleColumnMenu = ({
  anchorEl,
  open,
  handleCloseMenu,
  selectedColumn,
  handleSelectAllColumns,
  handleSelectColumn,
}) => {
    return (
        <>
            <CustomMenu
                id="user-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseMenu}
                className="assign-board-owner-list">
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={Object?.values(selectedColumn)?.every(
                                    (value) => value === true
                                )}
                                onChange={handleSelectAllColumns}
                            />
                        }
                        label="Select All"
                    />
                    {
                        dataGridColumn.filter(column => !["col1", "col2"].includes(column.field)).map((column, index) => (
                            <FormControlLabel
                                key={`watching-table-column-${index}`}
                                control={
                                    <Checkbox
                                        checked={selectedColumn[column.field]}
                                        onChange={() => handleSelectColumn(column.field)}
                                    />
                                }
                                label={column.headerName}
                            />
                        ))
                    }
                </FormGroup>
            </CustomMenu>
        </>
    )
}
